(function (angular, pmtEnv) {
	'use strict';

	angular.module('PinMeTo.services').factory('pmtEnvService', [
		'$location',
		function ($location) {
			const isPlacesApp = $location.absUrl().indexOf('listings') > -1;
			const isSocialApp = $location.absUrl().indexOf('location-posts') > -1;
			const isAccountSettingsApp = $location.absUrl().indexOf('account-settings') > -1;
			const isCustomerSuccessApp = $location.host().indexOf('cs.') > -1;

			const i18NextLoadPath = language =>
				language === 'en' && pmtEnv.env === 'dev'
					? '/static/locales/{{ns}}/dev.json'
					: `${pmtEnv.urls.translationsUrl}/{{ns}}/{{lng}}.json`;

			return {
				isDev: pmtEnv.env === 'dev',
				isTest: pmtEnv.env === 'test',
				isProd: pmtEnv.env === 'prod',
				isPlacesApp: isPlacesApp,
				isSocialApp: isSocialApp,
				isAccountSettingsApp: isAccountSettingsApp,
				isCustomerSuccessApp: isCustomerSuccessApp,
				listingsManagerUrl: pmtEnv.urls.listings,
				locationPostsUrl: pmtEnv.urls.locationPosts,
				accountSettingsUrl: pmtEnv.urls.accountSettings,
				listenRespondUrl: pmtEnv.urls.listen,
				loginUrl: pmtEnv.urls.login,
				insightsApiUrl: pmtEnv.urls.insightsApi,
				apiV3Url: pmtEnv.urls.apiV3,
				i18NextLoadPath: i18NextLoadPath
			};
		}
	]);
})(window.angular, window.pmtEnv);
